import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/documentation/documentation/node_modules/gatsby-theme-doctornpm/src/components/layout.js";
import shared from '../../../src/shared.js';
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const Note = makeShortcode("Note");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <Note mdxType="Note">
      <p><strong parentName="p">{`Note:`}</strong>{` This article only applies to users of the public npm registry.`}</p>
    </Note>
    <p>{`If you have a paid user account, but no longer need private packages, you can downgrade your paid organization to a free organization. When you downgrade from a paid to a free organization, you will lose the ability to install and publish private packages at the end of your last paid billing cycle. Your private packages will `}<em parentName="p">{`not`}</em>{` be made publicly visible when you downgrade to a free plan.`}</p>
    <ol>
      <li parentName="ol">
        <>{shared['user-login'].text}</>
        <>{shared['user-login'].image}</>
      </li>
      <li parentName="ol">
        <>{shared['billing-info'].text}</>
        <>{shared['billing-info'].image}</>
      </li>
      <li parentName="ol">
        <>{shared['billing-downgrade-selection'].text}</>
        <>{shared['billing-downgrade-selection'].image}</>
      </li>
      <li parentName="ol">
        <>{shared['billing-downgrade-confirm'].text}</>
        <>{shared['billing-downgrade-confirm'].image}</>
      </li>
    </ol>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      